<template>
    <div class="input-group">
        <input type="text" class="form-control custom-input-date bg-white" readonly="readonly" autocomplete="off"
               v-model="showText" v-if="!quickSearch">
        <vue-select label="firstName" :clearable="false" :filterable="false" :options="options" dir="rtl" class="form-control fast-search"
                    v-model="vueSelectedItem" @search="onSearch" v-if="quickSearch">
            <template #no-options="{ search, searching, loading, options }">
                <p class="f-13 mb-0 text-danger" v-if="searching && isNaN(search)">فقط عدد وارد کنید</p>
                <p class="f-13 mb-0" v-else-if="search.length >= 4">موردی یافت نشد</p>
                <p class="f-13 mb-0" v-else>
                    برای جستجو، حداقل 4 رقم از کد ملی را وارد کنید
                </p>
            </template>
            <template #option="{ firstName, lastName, nationalCode }">
                <p class="f-14 mb-0"> {{firstName}} {{lastName}}-- {{nationalCode}}</p>
            </template>
            <template #selected-option="{ firstName, lastName, nationalCode }">
                <p class="f-14 mb-0"> {{firstName}} {{lastName}}-- {{nationalCode}}</p>
            </template>
        </vue-select>
        <div class="input-group-append">
            <button type="button" class="btn btn-danger  mb-0 nbr" v-if="clearable"
                    @click="clear">
                <fa-icon icon="fas fa-remove"></fa-icon>
            </button>
            <button type="button" class="btn btn-info  mb-0 input-group-btn"
                    @click="show = true">
                <fa-icon icon="fas fa-search"></fa-icon>
            </button>
        </div>
    </div>
    <div class="modal fade "
         :class="[{'show' : show}, {'d-block' : show}]"
         id="person-browser" tabindex="-1" role="dialog" aria-labelledby="person-browser-label" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="person-browser-label">جستجو در پرسنل</h5>
                    <button type="button" class="close border-0 bg-white f-30"
                            @click="show = !show">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="formSearch">
                        <div class="row col-lg-12 col-md-12 col-sm-12 col-xs-12">

                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="firstName" class="form-control-label">نام</label>
                                    <input class="form-control" id="firstName"
                                           v-model="searchModel.firstName"
                                           type="text" autocomplete="off" />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="lastName" class="form-control-label">نام خانوادگی</label>
                                    <input class="form-control" id="lastName"
                                           v-model="searchModel.lastName"
                                           type="text" autocomplete="off" />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <div class="form-group">
                                    <label for="nationalCode" class="form-control-label">کد ملی</label>
                                    <input class="form-control" id="nationalCode"
                                           v-model="searchModel.nationalCode"
                                           type="text" autocomplete="off" />
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                            <button type="button" class="btn btn-info mb-0" @click="formSearch">جستجو</button>
                        </div>
                    </form>
                    <div class="table-responsive p-0 min-h-100">
                        <table v-if="listPersons && listPersons.length > 0"
                               class="table table-striped align-items-center justify-content-center mb-0">
                            <thead>
                                <tr>
                                    <th class=" text-center  ">نام و نام خانوادگی</th>
                                    <th class=" text-center  ">کد ملی</th>
                                    <th class=" text-center  ">کد پرسنلی</th>
                                    <th class=" text-center  ">مدرک تحصیلی</th>
                                    <th class=" text-center  ">رشته تحصیلی</th>
                                    <th class=" text-center  ">نوع پرسنل</th>
                                    <th class=" text-center  ">محل فعالیت</th>
                                    <th class="text-center ">انتخاب</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in listPersons">
                                    <td class=" text-center">
                                        {{item.firstName}} {{item.lastName}}
                                    </td>
                                    <td class=" text-center">
                                        {{item.nationalCode}}
                                    </td>
                                    <td class=" text-center">
                                        {{item.employedCode}}
                                    </td>
                                    <td class=" text-center">
                                        {{item.personEducationTitle}}
                                    </td>
                                    <td class=" text-center">
                                        {{item.personFieldTitle}}
                                    </td>
                                    <td class=" text-center">
                                        {{item.personTypeTitle}}
                                    </td>
                                    <td class=" text-center">
                                        {{organTypeTitle(item.organizationTypeEnum)}} {{item.organizationTitle}}
                                    </td>
                                    <td class="align-middle text-center">
                                        <button type="button" class="btn  mb-0"
                                                :class="isCheckedIndex(item.personId) > -1 ? 'btn-info' : 'btn-outline-info'"
                                                v-on:click="addToSelected(item)">
                                            انتخاب
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot v-if="listPersons && listPersons.length > 0 && listPersons[0].totalRecordsCount > currentPageSize">
                                <tr>
                                    <td colspan="4">
                                        <pagination :total-record-count="listPersons[0].totalRecordsCount" :page-index="listPersons[listPersons.length]" @change-callback="paginationCallback" />
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                        <div v-else-if="showNotFound" class="d-flex justify-content-center">
                            <p class="alert alert-info text-white col-10 mb-0 p-1 mt-2">موردی یافت نشد</p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer d-inline border-0">
                    <button v-if="allowMultiSelect" type="button" class="btn btn-success float-end mb-0"
                            @click="saveSelectedList">
                        ثبت اطلاعات
                    </button>
                    <button type="button" class="btn btn-secondary float-start mb-0"
                            @click="show = !show">
                        بستن
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade" :class="[{'show' : show}, {'d-none' : !show}]"></div>
</template>

<script>
    import PersonService from "@/services/Person/Person-service";

    export default {
        name: "PersonBrowser",
        props: {
            allowMultiSelect: {
                type: Boolean,
                default: false,
            },
            selectedList: {
                type: Array,
                default: [],
            },
            targetHospitalId: {
                type: Number,
                default: false
            },
            clearable: {
                type: Boolean,
                default: false,
            },
            quickSearch: {
                type: Boolean,
                default: false,
            }
        },
        emits: ["fnCallback"],
        components: {},
        data() {
            return {
                listPersons: [],
                options: [],
                vueSelectedItem: null,
                show: false,
                searchModel: {
                    firstName: '',
                    lastName: '',
                    natonalCode: '',
                },
                internalSelecedList: [],
                currentPageIndex: 0,
                currentPageSize: 25,
                showText: '',
                showNotFound: false
            };
        },
        methods: {
            getlist() {
                this.listPersons = [];
                this.searchModel.PageIndex = this.currentPageIndex;
                this.searchModel.PageSize = this.currentPageSize;

                if ((this.targetHospitalId ?? 0) > 0) {
                    this.searchModel.hospitalId = this.targetHospitalId;
                }

                PersonService.searchPerson(this.searchModel).then(response => {
                    let result = response.data;

                    if (!result.isSuccess) {
                        this.$toast.error(result.message);
                    }
                    else {
                        this.listPersons = result.data;
                        if (this.listPersons.length == 0) {
                            this.showNotFound = true;
                        }
                    }
                })
                    .catch(e => {
                        console.log(e);
                    });

            },
            closePanel(withSave) {
                this.show = false;
                if (withSave) {
                    this.setShowText();
                    this.$emit('onUpdate:selectedList', this.internalSelecedList);
                    this.$emit('fnCallback', this.internalSelecedList);
                }
            },
            saveSelectedList() {
                this.closePanel(true);
            },
            addToSelected(item) {
                if (this.allowMultiSelect) {
                    let itemIndex = this.isCheckedIndex(item.personId);
                    if (itemIndex > -1) {
                        this.internalSelecedList.splice(itemIndex, 1);
                    }
                    else
                        this.internalSelecedList.push(item);
                }
                else {
                    this.internalSelecedList = this.options = [item];
                    this.vueSelectedItem = item;
                    this.closePanel(true);
                }
            },
            paginationCallback(pageIndex, pageSize) {
                this.currentPageSize = pageSize;
                this.currentPageIndex = pageIndex;
                this.getlist();
            },
            formSearch() {
                this.currentPageIndex = 1;
                this.getlist();
            },
            clear() {
                this.internalSelecedList = [];
                this.vueSelectedItem = null;
                this.closePanel(true);
            },
            setShowText() {
                this.showText = this.internalSelecedList.map(function (v, i) { return v.firstName + ' ' + v.lastName; }).join(', ');
            },
            onSearch(search, loading) {
                if (!isNaN(search) && search.length >= 4) {
                    loading(true);
                    this.fastSearch(loading, search, this);
                }
            },
            fastSearch(loading, search, vm) {
                this.searchModel.PageIndex = 1;
                this.searchModel.PageSize = 1000;

                if ((this.targetHospitalId ?? 0) > 0) {
                    this.searchModel.hospitalId = this.targetHospitalId;
                }

                this.searchModel.nationalCode = search;

                PersonService.searchPerson(this.searchModel)
                    .then(response => {
                    let result = response.data;

                    if (!result.isSuccess) {
                        this.$toast.error(result.message);
                    }
                    else {
                        vm.options = result.data;
                    }
                    loading(false);
                })
                    .catch(e => {
                        console.log(e);
                        loading(false);
                    });

            },
        },
        created() {
            this.currentPageSize = this.$store.state.defaultPageSize;
        },
        watch: {
            selectedList(newVal) {
                if (newVal)
                    this.internalSelecedList = newVal;
                else
                    this.internalSelecedList = [];

                this.setShowText();
            },
            vueSelectedItem(newVal) {
                if (newVal) {
                    this.addToSelected(newVal);
                }
            }
        },
        computed: {
            isCheckedIndex() {
                let vm = this;
                return (itemId) => {
                    return vm.internalSelecedList.map(function (v, i) { return v.personId; })
                        .indexOf(itemId);

                    //    return vm.internalSelecedList.filter(function (v, i) {
                    //        return v.personId == itemId;
                    //    }).length > 0;

                };
            },
            organTypeTitle() {
                let vm = this;
                return (itemId) => {
                    switch (itemId) {
                        case 1:
                            return '';
                        case 2:
                            return 'دانشگاه';
                        case 3:
                            return 'بیمارستان';
                    }
                };
            }
        },
        mounted() {
            this.showNotFound = false;
        }
    };
</script>